
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AddressFields": [
      "Address",
      "PostalAddress"
    ],
    "ApprovalRequestAuthor": [
      "Operator",
      "SystemUser"
    ],
    "MessagingUserProfile": [
      "User",
      "Merchant",
      "Operator",
      "BusinessUser",
      "InternalMessagingUser",
      "OnboardingSpecialistUser",
      "SupportMessagingUser"
    ],
    "Identity": [
      "User",
      "BusinessUser",
      "Operator",
      "SystemUser",
      "PartnerUser"
    ],
    "SellablePriceSource": [
      "AmazonSellablePriceSource",
      "DealInventorySellablePriceSource",
      "DealSellablePriceSource",
      "EBaySellablePriceSource",
      "GoogleShoppingSellablePriceSource",
      "RawSellableFeedSellablePriceSource",
      "RawSellableGoogleProductSellablePriceSource",
      "RawSellableImpactSellablePriceSource",
      "RawSellableScraperSellablePriceSource",
      "RawSellableShopifySellablePriceSource",
      "RawSellableWalmartSellablePriceSource",
      "ScrapingSellablePriceSource",
      "YadavSellablePriceSource"
    ],
    "FulfillmentChannelWriter": [
      "Operator",
      "SystemUser"
    ],
    "AttributeSchemaAuthor": [
      "Operator",
      "SystemUser",
      "ImportedIdentity"
    ],
    "AttributeValidatorReference": [
      "CharacterCountAttributeValidatorReference",
      "ContactAvailableAttributeValidatorReference",
      "IdEntityTypeAttributeValidatorReference",
      "InRangeDecimalAttributeValidatorReference",
      "InRangeIntegerAttributeValidatorReference",
      "OAuthTokenNotMappedAttributeValidatorReference",
      "RegexAttributeValidatorReference",
      "SmsCapablePhoneNumberAttributeValidatorReference",
      "ValidEmailAddressAttributeValidatorReference"
    ],
    "AttributeSchemaMetadata": [
      "ExpertNoteAttributeSchemaMetadata",
      "GoogleShoppingFeedAttributeSchemaMetadata",
      "HiddenAttributeSchemaMetadata",
      "ProConAttributeSchemaMetadata",
      "SearchFacetCappedNumericAttributeSchemaMetadata",
      "SearchFacetDecimalScaleAttributeSchemaMetadata",
      "SearchFacetFixedIntegerBucketAttributeSchemaMetadata",
      "SearchFacetHistogramBucketAttributeSchemaMetadata",
      "SearchFacetNameAliasAttributeSchemaMetadata",
      "SearchFilterFieldAttributeSchemaMetadata"
    ],
    "AttributeValue": [
      "AttributeValueInteger",
      "AttributeValueIntegerRange",
      "AttributeValueDecimal",
      "AttributeValueDecimalRange",
      "AttributeValueText",
      "AttributeValueEnumeration",
      "AttributeValueDate",
      "AttributeValueDateRange",
      "AttributeValueTime",
      "AttributeValueTimeRange",
      "AttributeValueDateTime",
      "AttributeValueDateTimeRange",
      "AttributeValueZoneId",
      "AttributeValueId"
    ],
    "SellableSource": [
      "SellableSourceExternalId",
      "SellableSourceProductCatalog",
      "SellableSourceProductCatalogGroup",
      "SellableSourceStandardizedSellableGroup",
      "SellableSourceUrl"
    ],
    "TextViewModel": [
      "AttributedHtmlTextViewModel"
    ],
    "ImageViewModel": [
      "PathImageViewModel"
    ],
    "PathFlowOnComplete": [
      "PathFlowOnCompleteBroadcast",
      "PathFlowOnCompleteLead",
      "PathFlowOnCompleteNewPath",
      "PathFlowOnCompleteDealRequest",
      "PathFlowOnCompleteExpertReview",
      "PathFlowOnCompleteRedirectOnly",
      "PathFlowOnCompleteRedirectWithUpsert",
      "PathFlowOnCompleteExpertApplication"
    ],
    "ExpertApplicationReviewer": [
      "BusinessUser",
      "Operator"
    ],
    "DepartmentNavigationResponsiveMixin": [
      "DepartmentNavigationTopLevelItem",
      "DepartmentNavigationExpertSubSection",
      "DepartmentNavigationListSubSection"
    ],
    "DepartmentNavigationLink": [
      "DepartmentNavigationDealsLink",
      "DepartmentNavigationCategoryLink",
      "DepartmentNavigationSearchLink",
      "DepartmentNavigationCreatePathLink",
      "DepartmentNavigationExpertCommunityLink",
      "DepartmentNavigationDepartmentLink"
    ],
    "DepartmentNavigationSubSection": [
      "DepartmentNavigationExpertSubSection",
      "DepartmentNavigationListSubSection"
    ],
    "ArticleAuthor": [
      "User",
      "BusinessUser",
      "Operator"
    ],
    "ArticleContentBlock": [
      "ArticleEmbedMediaContentBlock",
      "ArticleMediaFileContentBlock",
      "ArticleRichTextContentBlock",
      "ArticleSellableContentBlock",
      "ArticleSellableListContentBlock"
    ],
    "DisplayFacet": [
      "BucketedDisplayFacet",
      "BucketedRangeDisplayFacet",
      "NumericRangeDisplayFacet"
    ],
    "NoteApprovalChangeByUnion": [
      "Operator",
      "BusinessUser",
      "SystemUser"
    ],
    "IndividualSellableProCon": [
      "IndividualSellableCustomProCon",
      "IndividualSellableAttributeProCon"
    ],
    "ExpertHiringFeedbackDetail": [
      "ExpertApplicationEvaluation",
      "ExpertApplicationSimpleRating",
      "ExpertInterviewFeedback"
    ],
    "PathFlowPageMetadata": [
      "BasicPathFlowPageMetadata",
      "ContactPrivacyMetadata",
      "ContactTCPAComplianceMetadata",
      "FacebookMessengerPathFlowPageMetadata",
      "FacebookTCPAComplianceMetadata",
      "GenericInfoBoxPageMetadata",
      "GenericModalPageMetadata",
      "InterstitialPathFlowPageMetadata",
      "PhoneExplanationModalMetadata",
      "RatingContactPageMetadata",
      "ReviewFooterPageMetadata",
      "TermsAndConditionsPathFlowPageMetadata",
      "TermsPrivacyMedicalPathFlowPageMetadata"
    ],
    "PathFlowQuestion": [
      "DatePathFlowQuestion",
      "DateRangePathFlowQuestion",
      "IdPathFlowQuestion",
      "InputTextPathFlowQuestion",
      "ListPathFlowQuestion",
      "NumericPathFlowQuestion",
      "OAuthEmailPathFlowQuestion",
      "UserContactPathFlowQuestion"
    ],
    "OfferTerms": [
      "ProductOfferTerms",
      "ServiceOfferTerms"
    ],
    "ReturnPolicy": [
      "NoReturnsAcceptedReturnPolicy",
      "StandardReturnPolicy"
    ],
    "PaymentSource": [
      "AffirmPaymentSource",
      "AfterpayPaymentSource",
      "DealPaymentSource",
      "PaypalPaymentSource",
      "StripePaymentSource"
    ],
    "PaymentEntity": [
      "BankCheckPaymentEntity",
      "InstallmentPaymentEntity",
      "Payment3DSecure",
      "PaymentCard",
      "PaypalPaymentEntity",
      "WireTransferPaymentEntity"
    ],
    "PaymentProcessorAccount": [
      "AffirmAccount",
      "AfterPayAccount",
      "DealPaymentAccount",
      "PaypalAccount",
      "StripeAccount"
    ],
    "OrderLineItemSource": [
      "OrderLineItemAdHocSource",
      "OrderLineItemBasePriceSource",
      "OrderLineItemExpertTipSource",
      "OrderLineItemGiftCardSource",
      "OrderLineItemGratuitySource",
      "OrderLineItemPrepaidIncidentalSource",
      "OrderLineItemRefundSource",
      "OrderLineItemSellableSource",
      "OrderLineItemShipmentSource"
    ],
    "SellableTerms": [
      "ServiceSellableTerms"
    ],
    "FulfillmentOrderSource": [
      "PartnerFulfillmentOrderSource",
      "ShopifyFulfillmentOrderSource"
    ],
    "EscalationUser": [
      "User",
      "Operator",
      "BusinessUser"
    ],
    "TicketUser": [
      "Operator"
    ],
    "TicketRequester": [
      "Operator",
      "SystemUser",
      "BusinessUser",
      "User"
    ],
    "TicketDetail": [
      "CancellationTicket",
      "ConsumerRefundTicket",
      "ExchangeTicket",
      "FollowupActionRequestTicket",
      "GeneralSupportTicket",
      "ItemClaimsGroupingTicket",
      "ItemUnavailableTicket",
      "LineItemClaimTicket",
      "LineItemTrackingUpdateTicket",
      "MerchantRefundTicket",
      "MissingItemTicket",
      "MissingSpecsTicket",
      "OrderAdjustmentTicket",
      "OrderInformationTicket",
      "OrderVerificationTicket",
      "ProductReturnTicket",
      "ReturnTicket",
      "TrackingInquiryTicket"
    ],
    "TicketActivityDetail": [
      "DueDateChangedActivity",
      "FieldUpdatedActivity",
      "TicketAssignedActivity",
      "TicketClosedActivity",
      "TicketCommentAddedActivity",
      "TicketCreatedActivity",
      "TicketDependencyUpdatedActivity",
      "TicketPickedUpActivity",
      "TicketQueueTransferActivity",
      "TicketReopenedActivity",
      "TicketsMergedActivity",
      "TicketSnoozeChangedActivity",
      "TicketUnassignedActivity"
    ],
    "TicketAuthor": [
      "SystemUser",
      "Operator"
    ],
    "OrderActivityDetail": [
      "ConfirmedReturnShippingLabelSentActivity",
      "DealInventoryClaimedActivity",
      "DealInventoryFulfillmentOrderCanceledActivity",
      "DealInventoryRequestCanceledActivity",
      "DealInventoryRequestedActivity",
      "DealInventoryRequestFailedActivity",
      "EscalationClosedActivity",
      "FulfillmentProcessUpdatedActivity",
      "ItemReturnReceivedActivity",
      "ItemReturnRequestedActivity",
      "ItemReturnShippedActivity",
      "MerchantClaimedActivity",
      "MerchantRefundUpdatedActivity",
      "OperatorAssignedActivity",
      "OrderAddressChangedActivity",
      "OrderEscalatedActivity",
      "OrderExpertContributionChangedActivity",
      "OrderItemReceivedActivity",
      "OrderItemShippedActivity",
      "OrderVerificationActivity",
      "RefundAmountAdjustedActivity",
      "RefundRequestedActivity",
      "RefundStatusUpdateActivity",
      "ReturnDestinationChangedActivity",
      "ReturnShipmentTrackingRemovedActivity",
      "ReturnShipmentTrackingUpdatedActivity",
      "ShipmentTrackingRemovedActivity",
      "ShipmentTrackingUpdatedActivity"
    ],
    "PromotionCreator": [
      "Operator",
      "User"
    ],
    "PromotionRuleReference": [
      "OrderAmountPromotionRuleReference",
      "PurchasedOrderCountPromotionRuleReference",
      "SellableAttributeFilterPromotionRuleReference",
      "SellableBrandFilterPromotionRuleReference",
      "SellableCategoryFilterPromotionRuleReference",
      "SellableFilterPromotionRuleReference",
      "UserUsageLimitPromotionRuleReference"
    ],
    "PromotionActionReference": [
      "AmountOffOrderPromotionActionReference",
      "PercentOffLineItemsPromotionActionReference"
    ],
    "PromotionSource": [
      "PromotionSourceReferee",
      "PromotionSourceReferrer",
      "PromotionSourceRegistration",
      "PromotionSourceSocialSharing"
    ],
    "TipMethod": [
      "TipMethodFixedAmount",
      "TipMethodPercentOfAmount"
    ],
    "GroupedOrderLineItems": [
      "TrackingGroupedOrderLineItems"
    ],
    "PaymentAction": [
      "StripeRequiredPaymentAction",
      "StripeRequiredSetupAction"
    ],
    "DealTerms": [
      "ProductDealTerms",
      "ServiceDealTerms",
      "EmptyDealTerms"
    ],
    "DealCreatedByUnion": [
      "Operator",
      "Merchant"
    ],
    "ExpertRecommendationRecord": [
      "ExpertRecommendationAssistantFirst",
      "ExpertRecommendationByLeastWorkloadRecord",
      "ExpertRecommendationByPerformanceWeightRecord"
    ],
    "SystemCuratedItemSource": [
      "PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource",
      "RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource",
      "TopRecommendationAndSimilarUserSystemCuratedItemSource",
      "TopRecommendedListSystemCuratedItemSource"
    ],
    "LeadSourceFlow": [
      "LeadSourceConversationStarterFlow",
      "LeadSourceDirectExpertChatFlow",
      "LeadSourceIncomingCallOrMessageFlow",
      "LeadSourcePathFlow",
      "LeadSourcePostOrderCheckinFlow",
      "LeadSourceRegistrationFlow"
    ],
    "LeadSourcePage": [
      "LeadSourceDepartmentPage",
      "LeadSourceExpertProfilePage",
      "LeadSourceGiftCardRedeemPage",
      "LeadSourceSellablePage",
      "LeadSourceSellableSearchPage",
      "LeadSourceSellableTopListPage"
    ],
    "TemplateMessageDeliveryRecipient": [
      "User",
      "BusinessUser"
    ],
    "TriggerLiteralValue": [
      "TriggerLiteralBooleanValue",
      "TriggerLiteralIntegerValue",
      "TriggerLiteralDecimalValue",
      "TriggerLiteralStringValue",
      "TriggerLiteralStringListValue",
      "TriggerLiteralDateValue",
      "TriggerLiteralIdValue",
      "TriggerLiteralIdListValue"
    ],
    "TriggerNode": [
      "TriggerAction",
      "TriggerBranch",
      "TriggerDelay",
      "TriggerFilter",
      "TriggerJump",
      "TriggerWait"
    ],
    "CampaignUnion": [
      "LeadCampaign",
      "Campaign"
    ],
    "FilterCondition": [
      "FilterFieldCondition",
      "FilterLogicalCondition"
    ],
    "FilterFieldDefinition": [
      "FilterAttributeFieldDefinition",
      "FilterBooleanFieldDefinition",
      "FilterDateRangeFieldDefinition",
      "FilterGeoPointFieldDefinition",
      "FilterIdFieldDefinition",
      "FilterNumberRangeFieldDefinition",
      "FilterStringFieldDefinition",
      "LeadTouchFilterFieldDefinition"
    ],
    "FilterFieldValue": [
      "FilterFieldIdValue",
      "FilterFieldStringValue",
      "FilterFieldAttributeValue",
      "FilterFieldBooleanValue",
      "FilterFieldDateRangeValue",
      "FilterFieldGeoSearchValue",
      "FilterFieldNumberRangeValue",
      "FilterFieldRelativeDateRangeValue",
      "LeadTouchFilterFieldValue"
    ],
    "CampaignSettings": [
      "LeadCampaignSettings"
    ],
    "CampaignAudienceIntegration": [
      "CampaignAudienceFacebookIntegration"
    ],
    "TriggerParameter": [
      "TriggerEntityFieldReference",
      "TriggerEventParameterReference",
      "TriggerLiteralBooleanValue",
      "TriggerLiteralIntegerValue",
      "TriggerLiteralDecimalValue",
      "TriggerLiteralStringValue",
      "TriggerLiteralStringListValue",
      "TriggerLiteralDateValue",
      "TriggerLiteralIdValue",
      "TriggerLiteralIdListValue"
    ],
    "ChannelTemplate": [
      "EmailTemplate",
      "FacebookTemplate",
      "InAppTemplate",
      "PushNotificationTemplate",
      "SlackTemplate",
      "SmsTemplate"
    ],
    "TemplateDataModel": [
      "TemplateCustomQueryDataModel",
      "TemplateNamedQueryDataModel",
      "TemplateObjectTemplateDataModel"
    ],
    "LeadActivity": [
      "ConsumerCalledActivity",
      "ConsumerFirstMessageSentActivity",
      "ConsumerReviewAddedActivity",
      "DelegateExpertChangedActivity",
      "LeadArchivedActivity",
      "LeadCreatedActivity",
      "LeadEscalationChangedActivity",
      "LeadEscalationStartedActivity",
      "LeadGiftCardRedeemedActivity",
      "LeadOrderPaidActivity",
      "LeadPaymentFailedActivity",
      "LeadPaymentSucceededActivity",
      "LeadReassignedActivity",
      "LeadRequestSubmittedActivity",
      "LeadStopRequestedActivity",
      "QualityConversationEstablishedActivity",
      "QualityConvoWithCurationEstablishedActivity",
      "SnoozeChangedActivity",
      "WokeUpFromSnoozeActivity"
    ],
    "SupportTaskActivity": [
      "AssignSupportTaskActivity",
      "CreateSupportTaskActivity",
      "DelegateLeadSupportTaskActivity",
      "DismissSupportTaskActivity",
      "EscalateLeadForDelegationSupportTaskActivity",
      "EscalateLeadForReassignmentSupportTaskActivity",
      "LeadSpamRiskSupportTaskActivity",
      "ReassignLeadSupportTaskActivity",
      "RequestOrderSupportForLeadSupportTaskActivity",
      "SnoozeSupportTaskActivity",
      "SuggestLeadActionsSupportTaskActivity",
      "UnassignSupportTaskActivity",
      "UnsnoozeSupportTaskActivity"
    ],
    "SupportTask": [
      "LeadSupportTask",
      "OrderSupportTask"
    ],
    "SupportTaskActor": [
      "Operator",
      "SystemUser"
    ],
    "ExpertCuratedItemRemovedBy": [
      "User",
      "BusinessUser"
    ],
    "EditorialReviewRating": [
      "EditorialReviewRatingFiveStar"
    ],
    "ConversationStarterDefinitionCriteria": [
      "SellableConversationStarterDefinitionCriteria",
      "SellableSearchConversationStarterDefinitionCriteria"
    ],
    "ExpertPresence": [
      "ExpertPresenceAway",
      "ExpertPresenceOffShift",
      "ExpertPresenceOnCall",
      "ExpertPresenceOnShift",
      "ExpertPresenceOnStandby"
    ],
    "BusinessUserActivity": [
      "ExpertActivatedActivity",
      "ExpertDeactivatedActivity",
      "ExpertLeadGateAddedActivity",
      "ExpertLeadGateRemovedActivity",
      "StartOnCallActivity",
      "StartReceivingLeadsActivity",
      "StopOnCallActivity",
      "StopReceivingLeadsActivity"
    ],
    "PayComponentRule": [
      "PayComponentCommissionRule",
      "PayComponentFirstShiftsGuaranteedRule",
      "PayComponentHourlyOnCallRule",
      "PayComponentQualityConversationRule",
      "PayComponentReferralFirstOrderRule",
      "PayComponentTeamLeadCommissionRule",
      "PayComponentTipRule"
    ],
    "SchedulingUserIdentity": [
      "Operator",
      "BusinessUser"
    ],
    "ShiftProbation": [
      "ExpertShiftProbation"
    ],
    "ShiftChangeRequest": [
      "ShiftGiveUpRequest",
      "ShiftSwapRequest"
    ],
    "ExternalProfile": [
      "FacebookMessengerProfile",
      "PiplProfile"
    ],
    "ReferralSource": [
      "ReferralSourceConsumerGeneric",
      "ReferralSourceConsumerToExpert",
      "ReferralSourceExpertDirect"
    ],
    "UserActivity": [
      "ViewSellableUserActivity",
      "CheckoutStartedUserActivity",
      "VoiceCallUserActivity"
    ],
    "SummarizedUserActivity": [
      "SummarizedViewSellableUserActivity",
      "SummarizedAddSellableUserActivity",
      "SummarizedCheckoutStartedUserActivity",
      "SummarizedPaymentInfoEnteredUserActivity",
      "SummarizedRemoveSellableUserActivity",
      "SummarizedSavedSellableUserActivity",
      "SummarizedUnSavedSellableUserActivity",
      "SummarizedViewCartUserActivity",
      "SummarizedViewCuratedListUserActivity"
    ],
    "UserJourneyStage": [
      "UserJourneyLeadStage",
      "UserJourneyNewStage",
      "UserJourneyOrderStage"
    ],
    "ApprovalRequestActivityEntryDetail": [
      "SubmitForReviewApprovalRequestActivityEntryDetail",
      "ApproveApprovalRequestActivityEntryDetail",
      "CloseApprovalRequestActivityEntryDetail",
      "CommentApprovalRequestActivityEntryDetail",
      "PublishApprovalRequestActivityEntryDetail",
      "RejectApprovalRequestActivityEntryDetail"
    ],
    "ApprovalRequestEntity": [
      "AttributeSchemaApprovalRequestEntity",
      "PathSchemaApprovalRequestEntity",
      "PathSchemaFragmentApprovalRequestEntity"
    ],
    "RenderedChannelContent": [
      "RenderedEmailContent",
      "RenderedFacebookContent",
      "RenderedInAppContent",
      "RenderedPushNotificationContent",
      "RenderedSlackContent",
      "RenderedSmsContent"
    ],
    "TaskPayload": [
      "MerchantUploadTaskPayload",
      "DealUploadTaskPayload",
      "SellableUploadTaskPayload",
      "SellablePriceUploadTaskPayload",
      "BrandUploadTaskPayload",
      "FeaturedSellableContentUploadTaskPayload",
      "SellableUpdateTaskPayload",
      "SellableDeactivationTaskPayload",
      "SellableInventoryUploadTaskPayload",
      "ExpertDiscountCashUploadTaskPayload",
      "InvoicedShippingCostUploadTaskPayload"
    ],
    "CallParticipant": [
      "BusinessUser",
      "User"
    ],
    "PathGraphContainer": [
      "PathSchemaRevision",
      "PathSchemaFragmentRevision"
    ],
    "PathGraphAuthor": [
      "Operator",
      "SystemUser",
      "ImportedIdentity"
    ],
    "CommonPathSchemaRevision": [
      "PathSchemaRevision",
      "PathSchemaFragmentRevision"
    ],
    "PathEditorValidationErrorContainer": [
      "RichPathGraph",
      "RichPathNode"
    ],
    "PathEditorValidationErrorTarget": [
      "BranchRulePathEditorValidationErrorTarget",
      "ListQuestionChoicePathEditorValidationErrorTarget",
      "PortPathEditorValidationErrorTarget",
      "QuestionPathEditorValidationErrorTarget"
    ],
    "PathNodeConfig": [
      "BranchContainerPathNodeConfig",
      "BranchRulePathNodeConfig",
      "BranchFallbackRulePathNodeConfig",
      "CreateAccountActionPathNodeConfig",
      "CreateConsumerExpertReviewActionPathNodeConfig",
      "CreateExpertApplicationActionPathNodeConfig",
      "CreateRequestLeadActionPathNodeConfig",
      "EndPathNodeConfig",
      "InterstitialPathNodeConfig",
      "PathSchemaFragmentEndPathNodeConfig",
      "PathSchemaFragmentPathNodeConfig",
      "PathSchemaFragmentReferencePathNodeConfig",
      "PathSchemaPathNodeConfig",
      "PathSchemaReferencePathNodeConfig",
      "QuestionsPathNodeConfig",
      "RedirectPathNodeConfig",
      "StartPathNodeConfig"
    ],
    "PathNodeDynamicExpanderState": [
      "PathSchemaFragmentReferencePathNodeDynamicExpanderState",
      "PathSchemaReferencePathNodeDynamicExpanderState"
    ],
    "PathNodeEditorViewModel": [
      "ConditionPathNodeEditorViewModel",
      "DefaultPathNodeEditorViewModel"
    ],
    "PathEditorRichTextContentPart": [
      "NewLinePathEditorRichTextContentPart",
      "TextPathEditorRichTextContentPart"
    ],
    "PathConditionOperand": [
      "PathConditionOperandRepositoryEntry",
      "PathConditionAttributeOperand",
      "PathConditionExperimentOperand",
      "PathConditionLiteralBigDecimalOperand",
      "PathConditionLiteralBigDecimalRangeOperand",
      "PathConditionLiteralEnumOperand",
      "PathConditionLiteralLongOperand",
      "PathConditionLiteralLongRangeOperand",
      "PathConditionLiteralStringOperand"
    ],
    "PathConditionEnumDeclaration": [
      "PathConditionAttributeEnumDeclaration",
      "PathConditionStaticEnumDeclaration"
    ],
    "SellableSearchError": [
      "InvalidSearchQuerySellableSearchError"
    ],
    "ErrorMessage": [
      "InvalidSearchQuerySellableSearchError",
      "NotEligibleStateApprovableEntityDependencyResolutionError",
      "NotFoundApprovableEntityDependencyResolutionError",
      "RecursiveUsageApprovableEntityDependencyResolutionError",
      "AlreadySubmittedApprovalRequestSubmitDraftEditError",
      "DependencyRequiredApprovalRequestSubmitDraftEditError",
      "NoSuchDependencyApprovalRequestSubmitDraftEditError",
      "AlreadySubmittedApprovalRequestCreationError",
      "ApprovalEntitiesChangedApprovalRequestCreationError",
      "DependencyResolutionFailedApprovalRequestCreationError",
      "ApprovableEntityNotReadyApprovalRequestCreationError",
      "ArchiveFailedApprovalRequestCreationError",
      "DefaultErrorMessage",
      "DraftExistsCreatePathSchemaRevisionError",
      "RevisionExistsCreatePathSchemaRevisionError",
      "MalformedSlugCreatePathSchemaRevisionError",
      "NoSuchPathSchemaCreatePathGraphFlowError",
      "AlreadyCompletedNavigatePathGraphFlowError",
      "UploadMediaNoFileError",
      "NotFullyAppliedSellableEditError",
      "VariationDimensionSellableRemoveAttributeError",
      "UpdateAlreadyExistsExpertCuratedItemEditError",
      "NoteEditErrorExpertCuratedItemEditError",
      "InvalidAttributeForDepartmentExpertCuratedItemNoteEditError",
      "InvalidNoteStateExpertCuratedItemNoteEditError",
      "UnsupportedNoteStateExpertCuratedItemNoteEditError",
      "ProsAndConsErrorExpertCuratedItemNoteEditError",
      "CustomDisplayNameTooShortExpertCuratedItemProsAndConsEditError",
      "CustomDisplayNameTooLongExpertCuratedItemProsAndConsEditError",
      "AttributeEnumEntryDoesNotExistExpertCuratedItemProsAndConsEditError",
      "InvalidSavedExpertCuratedItemSavedExpertCuratedItemsEditExpertCuratedItemNoteError",
      "NoExpertCuratedItemNoteToUpdateSavedExpertCuratedItemsEditExpertCuratedItemNoteError",
      "NoteEditErrorSavedExpertCuratedItemsEditExpertCuratedItemNoteError",
      "NoPublishedVariantParentProductCatalogPublishError",
      "InconsistentVariationDimensionsProductCatalogPublishError",
      "ArchivedProductCatalogPublishError",
      "ConflictingProductIdentifierProductCatalogPublishError",
      "MissingAttributeProductCatalogPublishError",
      "InvalidVariantProductCatalogPublishError",
      "AlreadyCreatedProductCatalogDraftFromSellableError",
      "NoProductIdentifierProductCatalogDraftFromSellableError",
      "ParentNotExistProductCatalogDraftFromSellableError",
      "DraftExistsProductCatalogCreateDraftRevisionError",
      "CopyFromDraftNotAllowedProductCatalogCopyRevisionAsDraftError",
      "NotDraftProductCatalogUpdateError",
      "NotLatestRevisionProductCatalogArchiveRevisionError",
      "PublishedNotLatestRevisionProductCatalogArchiveRevisionError",
      "MissingAttributeProductCatalogUpdateError",
      "MissingRawAttributeProductCatalogUpdateError",
      "SellableNotFromCatalogProductCatalogPublishFromSellablesError",
      "ArchivedProductCatalogGroupPublishError",
      "ConflictingSkuProductCatalogGroupPublishError",
      "MissingAttributeProductCatalogGroupPublishError",
      "AlreadyCreatedProductCatalogGroupDraftFromSellableError",
      "DraftExistsProductCatalogGroupCreateDraftRevisionError",
      "CopyFromDraftNotAllowedProductCatalogGroupCopyRevisionAsDraftError",
      "NotDraftProductCatalogGroupUpdateError",
      "NotLatestRevisionProductCatalogGroupArchiveRevisionError",
      "PublishedNotLatestRevisionProductCatalogGroupArchiveRevisionError",
      "PublishedVariantsProductCatalogGroupArchiveRevisionError",
      "MissingAttributeProductCatalogGroupUpdateError",
      "MissingRawAttributeProductCatalogGroupUpdateError",
      "SellableNotFromCatalogGroupProductCatalogGroupPublishFromSellablesError",
      "AccountExistsCreateAccountPathNodeFlowViewModelError",
      "ApprovableEntitySwitchToPublishFailedApprovalRequestPublishError",
      "DefaultQuestionPathNodeFlowViewModelValidationError",
      "RequireLoginQuestionPathNodeFlowViewModelValidationError",
      "ErrorPathNodeFlowViewModel",
      "InvalidStateApprovalRequestPublishError",
      "NodeNotTraversedNavigatePathGraphFlowError",
      "NotApprovedApprovalRequestPublishError"
    ],
    "SellableSearchPageModule": [
      "SellableSearchPageArticleModule",
      "SellableSearchPageConversationStarterModule",
      "SellableSearchPageTopListModule"
    ],
    "SellableSearchPageRelatedSearchItem": [
      "ArticleRevision",
      "SellableTopList",
      "SellableSearchPageRelatedSearch"
    ],
    "SavedSearchResultConnection": [
      "LeadSearchConnection"
    ],
    "ContentValue": [
      "ContentBooleanValue",
      "ContentStringValue",
      "ContentIntValue",
      "ContentFloatValue",
      "ContentAsset",
      "ContentValueArray",
      "ContentObject"
    ],
    "ContentSelectionMethod": [
      "ExperimentContentSelectionMethod",
      "HardcodedContentSelectionMethod"
    ],
    "ExpertCuratedActivityFeedItem": [
      "ExpertCuratedActivityFeedOrderItem"
    ],
    "TriggerValidationEntity": [
      "Trigger",
      "CommTemplateType"
    ],
    "ExternalInventoryItemSource": [
      "ShopifyExternalInventoryItemSource"
    ],
    "PayComponentSummary": [
      "PayComponentCommissionSummary",
      "PayComponentFirstShiftsGuaranteedSummary",
      "PayComponentHourlyOnCallSummary",
      "PayComponentManualAdjustmentSummary",
      "PayComponentQualityConversationSummary",
      "PayComponentReferralFirstOrderSummary",
      "PayComponentTeamLeadCommissionSummary",
      "PayComponentTipSummary"
    ],
    "PayLineItemSource": [
      "PayLineItemCommissionSource",
      "PayLineItemFirstShiftsGuaranteedSource",
      "PayLineItemHourlyOnCallSource",
      "PayLineItemManualAdjustmentSource",
      "PayLineItemQualityConversationSource",
      "PayLineItemReferralFirstOrderSource",
      "PayLineItemTeamLeadCommissionSource",
      "PayLineItemTipSource"
    ],
    "RawSellableSource": [
      "DealInventoryRawSellableSource",
      "RawSellableGoogleShoppingFeedSource",
      "RawSellableLevelNineFeedSource",
      "RawSellableGoogleShoppingSearchSource",
      "RawSellableImpactSource",
      "RawSellableScraperSource",
      "RawSellableShopifySource",
      "RawSellableWalmartSource"
    ],
    "RawSellableStandardizationRuleCondition": [
      "RawSellableStandardizationRuleBinaryCondition",
      "RawSellableStandardizationRuleConstantCondition",
      "RawSellableStandardizationRuleLogicalCondition"
    ],
    "RawSellableStandardizationAction": [
      "RawSellableStandardizationCopyAttributeValueAction",
      "RawSellableStandardizationDeactivateAction",
      "RawSellableStandardizationHideFromConsumerSearchAction",
      "RawSellableStandardizationMarkNoneVariantAction",
      "RawSellableStandardizationMarkOutOfStockAction",
      "RawSellableStandardizationRemoveAttributeAction",
      "RawSellableStandardizationRenameAttributeAction",
      "RawSellableStandardizationReplaceAttributeValueAction",
      "RawSellableStandardizationSetAttributeValueAction",
      "RawSellableStandardizationSetAttributeVariationDimensionAction",
      "RawSellableStandardizationSetBrandAction",
      "RawSellableStandardizationSetCategoryAction",
      "RawSellableStandardizationSetDescriptionAction",
      "RawSellableStandardizationSetMpnAction",
      "RawSellableStandardizationSetTitleAction",
      "RawSellableStandardizationSetVariationGroupReferenceAction",
      "RawSellableStandardizationSetVariationGroupTitleAction"
    ],
    "RawSellableStandardizationFieldMeta": [
      "RawSellableStandardizationAttributeValueFieldMeta",
      "RawSellableStandardizationAttributeVariationDimensionFieldMeta",
      "RawSellableStandardizationPredefinedFieldMeta"
    ],
    "TicketTimelineItem": [
      "TicketActivityTimelineItem",
      "TicketCommentTimelineItem",
      "TicketOrderActivityTimelineItem",
      "TicketWorklogTimelineItem"
    ],
    "ConditionDefinition": [
      "AlwaysTrueConditionDefinition",
      "LogicalConditionDefinition",
      "StringBinaryConditionDefinition",
      "SubjectIdInConditionDefinition"
    ],
    "ExperimentUsage": [
      "CodeExperimentUsage",
      "CommTemplateExperimentUsage",
      "ContentSelectionRuleExperimentUsage",
      "TriggerExperimentUsage"
    ],
    "LedgerTransactionDetails": [
      "LedgerTransactionAuthorizeAndPostDetails",
      "LedgerTransactionAuthorizeDetails",
      "LedgerTransactionCancelAuthorizationDetails",
      "LedgerTransactionExtendAuthorizationDetails",
      "LedgerTransactionPostDetails"
    ],
    "ApprovableEntityDependencyResolutionError": [
      "NotEligibleStateApprovableEntityDependencyResolutionError",
      "NotFoundApprovableEntityDependencyResolutionError",
      "RecursiveUsageApprovableEntityDependencyResolutionError"
    ],
    "ApprovalRequestSubmitDraftEditError": [
      "AlreadySubmittedApprovalRequestSubmitDraftEditError",
      "DependencyRequiredApprovalRequestSubmitDraftEditError",
      "NoSuchDependencyApprovalRequestSubmitDraftEditError"
    ],
    "ApprovalRequestCreationError": [
      "AlreadySubmittedApprovalRequestCreationError",
      "ApprovalEntitiesChangedApprovalRequestCreationError",
      "DependencyResolutionFailedApprovalRequestCreationError",
      "ApprovableEntityNotReadyApprovalRequestCreationError",
      "ArchiveFailedApprovalRequestCreationError"
    ],
    "CommentOnApprovalRequestError": [
      "DefaultErrorMessage"
    ],
    "ApproveApprovalRequestError": [
      "DefaultErrorMessage"
    ],
    "RejectApprovalRequestError": [
      "DefaultErrorMessage"
    ],
    "ApprovalRequestPublishError": [
      "ApprovableEntitySwitchToPublishFailedApprovalRequestPublishError",
      "InvalidStateApprovalRequestPublishError",
      "NotApprovedApprovalRequestPublishError"
    ],
    "CloseApprovalRequestError": [
      "DefaultErrorMessage"
    ],
    "AttributeSchemaRevisionPayload": [
      "CreateAttributeSchemaRevisionPayload",
      "CopyAttributeSchemaRevisionAsNewVersionPayload",
      "PublishAttributeSchemaRevisionPayload",
      "DeleteDraftAttributeSchemaRevisionPayload",
      "DeprecateAttributeSchemaRevisionPayload",
      "UpdateAttributeSchemaRevisionPayload",
      "UpsertEnumEntriesIntoAttributeSchemaRevisionPayload",
      "ReorderEnumEntriesInAttributeSchemaRevisionPayload",
      "RemoveDraftEnumEntriesFromAttributeSchemaRevisionPayload",
      "UpsertMetadataIntoAttributeSchemaRevisionPayload",
      "RemoveMetadataFromAttributeSchemaRevisionPayload",
      "UpsertValidatorIntoAttributeSchemaRevisionPayload",
      "RemoveValidatorFromAttributeSchemaRevisionPayload"
    ],
    "EncodedAuthenticationTokensPayload": [
      "AuthenticationResultPayload",
      "AuthenticateByExternalOAuthTokenPayload",
      "CreatePasswordPayload",
      "ResetPasswordPayload",
      "ChangePasswordPayload",
      "RefreshAccessTokenPayload",
      "AssumeOperatorIdentityPayload",
      "ReleaseOperatorIdentityPayload",
      "AssumeConsumerIdentityPayload",
      "ReleaseConsumerIdentityPayload",
      "AssumeBusinessUserIdentityPayload",
      "ReleaseBusinessUserIdentityPayload",
      "CreatePathFlowPayload",
      "SubmitPathFlowPagePayload",
      "CreatePathGraphFlowPayload",
      "VisitPathGraphFlowPayload",
      "SubmitPathNodeFlowInputCommandsPayload",
      "AssumePartnerUserIdentityPayload",
      "ReleasePartnerUserIdentityPayload"
    ],
    "CreatePathSchemaRevisionError": [
      "DraftExistsCreatePathSchemaRevisionError",
      "RevisionExistsCreatePathSchemaRevisionError",
      "MalformedSlugCreatePathSchemaRevisionError"
    ],
    "CommonPathEditorPayload": [
      "ExecutePathEditorNodeConfigCommandPayload",
      "ExecutePathEditorUndoPayload",
      "ExecutePathEditorRedoPayload",
      "ExecutePathEditorSetEdgePayload",
      "ExecutePathEditorRemoveEdgePayload",
      "ExecutePathEditorMoveNodePayload",
      "ExecutePathEditorRemoveNodePayload",
      "TogglePathEditorNodeExpansionPayload"
    ],
    "SideEffectPathEditorPayload": [
      "ExecutePathEditorNodeConfigCommandPayload",
      "ExecutePathEditorSetEdgePayload",
      "ExecutePathEditorRemoveEdgePayload",
      "ExecutePathEditorMoveNodePayload",
      "ExecutePathEditorRemoveNodePayload"
    ],
    "PathNodeFlowViewModel": [
      "CreateAccountPathNodeFlowViewModel",
      "DryRunInfoPathNodeFlowViewModel",
      "ErrorPathNodeFlowViewModel",
      "InterstitialPathNodeFlowViewModel",
      "QuestionsPathNodeFlowViewModel",
      "RedirectPathNodeFlowViewModel"
    ],
    "PathGraphFlowRequestEvent": [
      "EntityCreatedPathGraphFlowRequestEvent",
      "PathCompletedPathGraphFlowRequestEvent"
    ],
    "CreatePathGraphFlowError": [
      "NoSuchPathSchemaCreatePathGraphFlowError"
    ],
    "NavigatePathGraphFlowError": [
      "AlreadyCompletedNavigatePathGraphFlowError"
    ],
    "SetupPaymentSourcePayloadError": [
      "DefaultErrorMessage"
    ],
    "UploadMediaError": [
      "UploadMediaNoFileError"
    ],
    "BulkSetSellableAttributeError": [
      "NotFullyAppliedSellableEditError"
    ],
    "BulkSetSellableRawAttributeError": [
      "NotFullyAppliedSellableEditError"
    ],
    "BulkSellableRemoveAttributeError": [
      "NotFullyAppliedSellableEditError",
      "VariationDimensionSellableRemoveAttributeError"
    ],
    "BulkSellableRemoveRawAttributeError": [
      "NotFullyAppliedSellableEditError",
      "VariationDimensionSellableRemoveAttributeError"
    ],
    "ExpertCuratedItemEditError": [
      "UpdateAlreadyExistsExpertCuratedItemEditError",
      "NoteEditErrorExpertCuratedItemEditError"
    ],
    "ExpertCuratedItemNoteEditError": [
      "InvalidAttributeForDepartmentExpertCuratedItemNoteEditError",
      "InvalidNoteStateExpertCuratedItemNoteEditError",
      "UnsupportedNoteStateExpertCuratedItemNoteEditError",
      "ProsAndConsErrorExpertCuratedItemNoteEditError"
    ],
    "ExpertCuratedItemProsAndConsEditError": [
      "CustomDisplayNameTooShortExpertCuratedItemProsAndConsEditError",
      "CustomDisplayNameTooLongExpertCuratedItemProsAndConsEditError",
      "AttributeEnumEntryDoesNotExistExpertCuratedItemProsAndConsEditError"
    ],
    "SavedExpertCuratedItemsEditExpertCuratedItemNoteError": [
      "InvalidSavedExpertCuratedItemSavedExpertCuratedItemsEditExpertCuratedItemNoteError",
      "NoExpertCuratedItemNoteToUpdateSavedExpertCuratedItemsEditExpertCuratedItemNoteError",
      "NoteEditErrorSavedExpertCuratedItemsEditExpertCuratedItemNoteError"
    ],
    "MessageRichCard": [
      "ContactCollectionRichCard",
      "ConversationStarterRichCard",
      "ExpertAwayAutoReplyRichCard",
      "ExpertFeedbackRequestRichCard",
      "ExpertJoinedRichCard",
      "ExpertReferralRequestRichCard",
      "GuestChatCreateRequestRichCard",
      "HowCuratedWorksRichCard",
      "InterestedInCuratedOrderRichCard",
      "NewBookableCuratedOrderRichCard",
      "NewCuratedItemsRichCard",
      "NewCuratedOrderListRichCard",
      "NewCustomCuratedOrderRichCard",
      "PaymentVerificationRequestRichCard",
      "PriceMatchRequestRichCard",
      "RequestConfirmationRichCard",
      "SellableRequestRichCard",
      "SimpleCuratedOrderRichCard",
      "SystemCuratedItemsRichCard",
      "SystemCuratedItemSurveyRichCard",
      "UpdatedCuratedItemsRichCard"
    ],
    "ProductCatalogPublishError": [
      "NoPublishedVariantParentProductCatalogPublishError",
      "InconsistentVariationDimensionsProductCatalogPublishError",
      "ArchivedProductCatalogPublishError",
      "ConflictingProductIdentifierProductCatalogPublishError",
      "MissingAttributeProductCatalogPublishError",
      "InvalidVariantProductCatalogPublishError"
    ],
    "AttributeSchemaRevisionOrAttributeName": [
      "AttributeSchemaRevision",
      "AttributeName"
    ],
    "ProductCatalogCreateDraftFromSellableError": [
      "AlreadyCreatedProductCatalogDraftFromSellableError",
      "NoProductIdentifierProductCatalogDraftFromSellableError",
      "ParentNotExistProductCatalogDraftFromSellableError"
    ],
    "ProductCatalogCreateDraftRevisionError": [
      "DraftExistsProductCatalogCreateDraftRevisionError"
    ],
    "ProductCatalogCopyRevisionAsDraftError": [
      "CopyFromDraftNotAllowedProductCatalogCopyRevisionAsDraftError"
    ],
    "ProductCatalogUpdateDraftError": [
      "NotDraftProductCatalogUpdateError"
    ],
    "ProductCatalogArchiveRevisionError": [
      "NotLatestRevisionProductCatalogArchiveRevisionError",
      "PublishedNotLatestRevisionProductCatalogArchiveRevisionError"
    ],
    "ProductCatalogSetAttributeError": [
      "NotDraftProductCatalogUpdateError"
    ],
    "ProductCatalogSetRawAttributeError": [
      "NotDraftProductCatalogUpdateError"
    ],
    "ProductCatalogRemoveAttributeError": [
      "NotDraftProductCatalogUpdateError",
      "MissingAttributeProductCatalogUpdateError"
    ],
    "ProductCatalogReorderRawAttributesError": [
      "NotDraftProductCatalogUpdateError",
      "MissingRawAttributeProductCatalogUpdateError"
    ],
    "ProductCatalogPublishFromSellablesError": [
      "SellableNotFromCatalogProductCatalogPublishFromSellablesError"
    ],
    "ProductCatalogGroupPublishError": [
      "ArchivedProductCatalogGroupPublishError",
      "ConflictingSkuProductCatalogGroupPublishError",
      "MissingAttributeProductCatalogGroupPublishError"
    ],
    "ProductCatalogGroupCreateDraftFromSellableError": [
      "AlreadyCreatedProductCatalogGroupDraftFromSellableError"
    ],
    "ProductCatalogGroupCreateDraftRevisionError": [
      "DraftExistsProductCatalogGroupCreateDraftRevisionError"
    ],
    "ProductCatalogGroupCopyRevisionAsDraftError": [
      "CopyFromDraftNotAllowedProductCatalogGroupCopyRevisionAsDraftError"
    ],
    "ProductCatalogGroupUpdateDraftError": [
      "NotDraftProductCatalogGroupUpdateError"
    ],
    "ProductCatalogGroupArchiveRevisionError": [
      "NotLatestRevisionProductCatalogGroupArchiveRevisionError",
      "PublishedNotLatestRevisionProductCatalogGroupArchiveRevisionError",
      "PublishedVariantsProductCatalogGroupArchiveRevisionError"
    ],
    "ProductCatalogGroupSetAttributeError": [
      "NotDraftProductCatalogGroupUpdateError"
    ],
    "ProductCatalogGroupSetRawAttributeError": [
      "NotDraftProductCatalogGroupUpdateError"
    ],
    "ProductCatalogGroupRemoveAttributeError": [
      "NotDraftProductCatalogGroupUpdateError",
      "MissingAttributeProductCatalogGroupUpdateError"
    ],
    "ProductCatalogGroupReorderRawAttributesError": [
      "NotDraftProductCatalogGroupUpdateError",
      "MissingRawAttributeProductCatalogGroupUpdateError"
    ],
    "ProductCatalogGroupPublishFromSellablesError": [
      "SellableNotFromCatalogGroupProductCatalogGroupPublishFromSellablesError"
    ],
    "ExpertNotification": [
      "ExpertNotificationLeadEscalation",
      "ExpertNotificationLeadSurge",
      "ExpertNotificationPresenceStatusChange",
      "ExpertNotificationShiftEnded"
    ],
    "FacetImageMetadata": [
      "BackgroundFacetImageMetadata",
      "IconFacetImageMetadata"
    ],
    "PathCondition": [
      "PathConditionComparison",
      "PathConditionLogical"
    ],
    "QuestionPathNodeFlowViewModelValidationError": [
      "DefaultQuestionPathNodeFlowViewModelValidationError",
      "RequireLoginQuestionPathNodeFlowViewModelValidationError"
    ],
    "CreateAccountPathNodeFlowViewModelError": [
      "AccountExistsCreateAccountPathNodeFlowViewModelError"
    ],
    "PathQuestionSchema": [
      "DatePathQuestionSchema",
      "InputTextPathQuestionSchema",
      "ListPathQuestionSchema",
      "NumericPathQuestionSchema"
    ],
    "QuestionPathNodeFlowViewModel": [
      "DateQuestionPathNodeFlowViewModel",
      "InputTextQuestionPathNodeFlowViewModel",
      "ListQuestionPathNodeFlowViewModel",
      "NumericQuestionPathNodeFlowViewModel"
    ],
    "InputTextPathFlowQuestionMixin": [
      "EmbeddedInputTextPathFlowQuestion",
      "InputTextPathFlowQuestion"
    ],
    "InputTextPathFlowQuestionValidation": [
      "InputTextPathFlowQuestionLengthValidation",
      "InputTextPathFlowQuestionNoArgValidation",
      "InputTextPathFlowQuestionRegexValidation"
    ],
    "GeoSearchValue": [
      "GeoZipCodeRadius"
    ],
    "InputTextPathQuestionSchemaValidationViewModel": [
      "InputTextPathQuestionSchemaLengthValidationViewModel",
      "InputTextPathQuestionSchemaRegexValidationViewModel"
    ],
    "SlugAwarePathNodeFlowViewModel": [
      "InterstitialPathNodeFlowViewModel",
      "QuestionsPathNodeFlowViewModel"
    ],
    "PathAttributeValue": [
      "PathStaticAttributeValue"
    ],
    "NumericPathQuestionSchemaRenderingStyle": [
      "NumericPathQuestionSchemaGenericRenderingStyle",
      "NumericPathQuestionSchemaLengthInInchesRenderingStyle",
      "NumericPathQuestionSchemaStarRatingRenderingStyle"
    ],
    "NumericRenderingStylePathQuestionPathNodeFlowViewModel": [
      "GenericNumericRenderingStylePathQuestionPathNodeFlowViewModel",
      "LengthInInchesNumericRenderingStylePathQuestionPathNodeFlowViewModel",
      "StarRatingNumericRenderingStylePathQuestionPathNodeFlowViewModel"
    ],
    "NumericValidationQuestionPathNodeFlowViewModel": [
      "InRangeNumericValidationQuestionPathNodeFlowViewModel"
    ],
    "PathQuestionsDisplayComponentSchema": [
      "TcpaCompliancePathQuestionsDisplayComponentSchema",
      "TermsAndConditionsPathQuestionsDisplayComponentSchema"
    ],
    "QuestionsDisplayComponentPathNodeFlowViewModel": [
      "TcpaComplianceQuestionsDisplayComponentPathNodeFlowViewModel",
      "TermsAndConditionsQuestionsDisplayComponentPathNodeFlowViewModel"
    ],
    "RawSellableFeedSource": [
      "RawSellableGoogleShoppingFeedSource",
      "RawSellableLevelNineFeedSource"
    ],
    "RawSellableSourceSpider": [
      "RawSellableSourceScrapinghubSpider"
    ],
    "RawSellableStandardizationRuleParameter": [
      "RawSellableStandardizationRuleEntityFieldReference",
      "RawSellableStandardizationRuleLiteralBooleanValue",
      "RawSellableStandardizationRuleLiteralDecimalValue",
      "RawSellableStandardizationRuleLiteralIdListValue",
      "RawSellableStandardizationRuleLiteralIdValue",
      "RawSellableStandardizationRuleLiteralIntegerValue",
      "RawSellableStandardizationRuleLiteralStringListValue",
      "RawSellableStandardizationRuleLiteralStringValue"
    ],
    "RedirectPathNodeFlowViewModelResult": [
      "ApplyFinishRedirectPathNodeFlowViewModelSuccess",
      "InboxRedirectPathNodeFlowViewModelSuccess",
      "ReturnToPreviousContextRedirectPathNodeFlowViewModelSuccess"
    ],
    "RenderedContent": [
      "MediaRenderedContent",
      "TextRenderedContent"
    ],
    "TriggerCondition": [
      "TriggerBinaryCondition",
      "TriggerExperimentCondition",
      "TriggerLogicalCondition"
    ],
    "TriggerDelayInterval": [
      "TriggerDelayDynamicInterval",
      "TriggerDelayFixedInterval",
      "TriggerDelayWithExperiment"
    ]
  }
};
      export default result;
    